import DoublePrizeTicketCard from '../DoublePrizeTicketCard/index';
import TicketCard from '../../TicketCard/TicketCard';

const NewPrizeCard = (props) => {
  // const isDoublePrize = props.raffles.length > 1;
  const isDoublePrize = false;
  if (isDoublePrize) {
    return <DoublePrizeTicketCard {...props} theme='light' />;
  }
  return <TicketCard {...props} theme='light' />;
};

export default NewPrizeCard;
